import { AxiosPromise } from 'axios';
import { IGetNotice, IGetNoticeDetail, IGetNotices, INoticeParams } from '../models/boardNotice.model';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/board/notice';

export const getNotices = (params: INoticeParams): AxiosPromise<IGetNotices> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
}

export const getNotice = (noticeCode: number): AxiosPromise<IGetNotice> => {
  return axios.get(`${uri}/${noticeCode}`);
}

export const createNotice = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateNotice = (noticeCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${noticeCode}`, data);
};

export const getNoticeCampus = (noticeCode: number): AxiosPromise<IGetNoticeDetail> => {
  return axios.get(`${uri}/campus/${noticeCode}`);
}

export const getNoticeGroup = (noticeCode: number): AxiosPromise<IGetNoticeDetail> => {
  return axios.get(`${uri}/group/${noticeCode}`);
}
